import { useNavigate } from "@remix-run/react";
import { AlertTriangle, ArrowLeft } from "lucide-react";

import { Button } from "~/components/ui/button";
import { AmbientBackground } from "~/modules/Landing/components/AmbientBackground";

type ErrorBoundaryProps = {
  stack?: string;
  message?: string;
};

const CustomErrorBoundary = ({ stack, message }: ErrorBoundaryProps) => {
  const navigate = useNavigate();

  return (
    <main className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-landing-cream px-4 py-12 text-landing-text">
      <AmbientBackground />
      <section className="relative z-10 w-full max-w-lg rounded-xl border border-landing-border bg-landing-white p-7 text-center shadow-landing-md sm:p-9">
        <span className="mx-auto flex size-14 items-center justify-center rounded-full bg-landing-red-50 text-landing-red">
          <AlertTriangle className="size-7" aria-hidden="true" />
        </span>
        <p className="mt-5 landing-eyebrow text-landing-red">No pudimos cargar esta pantalla</p>
        <h1 className="mt-2 font-display text-3xl font-semibold">Algo salió mal</h1>
        <p className="mt-3 text-sm leading-relaxed text-landing-muted">
          Podés volver a intentarlo o regresar al inicio. Si el problema continúa, comunicate con
          soporte.
        </p>
        {import.meta.env.DEV && message && (
          <p className="mt-4 rounded-lg bg-landing-stone-100 p-3 text-left font-mono text-xs text-landing-muted">
            {message}
          </p>
        )}
        {import.meta.env.DEV && stack && (
          <pre className="mt-3 max-h-48 overflow-auto rounded-lg bg-landing-stone-100 p-3 text-left text-xs text-landing-muted">
            {stack}
          </pre>
        )}
        <div className="mt-7 flex flex-col justify-center gap-2 sm:flex-row">
          <Button onClick={() => navigate(-1)} variant="brand-outline">
            <ArrowLeft className="mr-2 size-4" />
            <span>Volver</span>
          </Button>
          <Button onClick={() => navigate("/")} variant="brand">
            Ir al inicio
          </Button>
        </div>
      </section>
    </main>
  );
};

export default CustomErrorBoundary;
